import React, { useCallback, useRef, useState, useEffect } from "react";
import { useParams, withRouter } from "react-router-dom";

import MessageStripCompnt from "../../shared/components/UIElements/MessageStrip";
import { ValueState } from "@ui5/webcomponents-react/lib/ValueState";
import { Dialog } from "@ui5/webcomponents-react/lib/Dialog";
import { TextArea } from "@ui5/webcomponents-react/lib/TextArea";
import { Button } from "@ui5/webcomponents-react/lib/Button";
import { Table } from "@ui5/webcomponents-react/lib/Table";
import { TableColumn } from "@ui5/webcomponents-react/lib/TableColumn";
import { TableRow } from "@ui5/webcomponents-react/lib/TableRow";
import { TableCell } from "@ui5/webcomponents-react/lib/TableCell";
import { Text } from "@ui5/webcomponents-react/lib/Text";
import { ButtonDesign } from "@ui5/webcomponents-react/lib/ButtonDesign";
import "@ui5/webcomponents-icons/dist/icons/accept.js";
import "@ui5/webcomponents-icons/dist/icons/decline.js";
import "@ui5/webcomponents-icons/dist/icons/payment-approval.js";
import { PageBackgroundDesign } from "@ui5/webcomponents-react/lib/PageBackgroundDesign";
import { Page } from "@ui5/webcomponents-react/lib/Page";
import { ComboBox } from "@ui5/webcomponents-react/lib/ComboBox";
import { ComboBoxItem } from "@ui5/webcomponents-react/lib/ComboBoxItem";
import { Title } from "@ui5/webcomponents-react/lib/Title";
import { TitleLevel } from "@ui5/webcomponents-react/lib/TitleLevel";
import axios from "axios";

import "./DocumentDetails.css";

const DocumentDetails = (props) => {
  const supplierId = useParams().supplierId;
  const approvalId = useParams().approvalId;
  const title = "Document Details";
  const [error, setError] = useState("");
  const [documentsList, setDocumentsList] = useState([]);
  const [bpName, setBpName] = useState("");
  const [wizardName, setWizardName] = useState("");
  const [rejectReasons, setRejectReasons] = useState([]);

  const [reRenderTrigger, setReRenderTrigger] = useState(false);

  const [isPayrunApproved, setIsPayrunApproved] = useState(null);

  const [rejectionOption, setRejectionOption] = useState("reject_one");
  const [rejectionReasonCode, setRejectionReasonCode] = useState("");
  const [rejectionReasonComments, setRejectionReasonComments] = useState("");
  const [rejectionObjType, setRejectionObjType] = useState(0);
  const [rejectionDocNum, setRejectionDocNum] = useState(0);

  const [disableButtons, setDisableButtons] = useState(false);

  const getBpName = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/supplierName/` + approvalId + `/` + supplierId, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setBpName(response.data.CardName);
        getRejectReasons();
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getRejectReasons = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/reject/codes`, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setRejectReasons(response.data);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getPayrunSupplierDocs = async () => {
    setError(null);
    await axios
      .get(
        `/api/payruns/docs/` + approvalId + `/` + supplierId + `/` + props.user,
        {
          headers: { Authorization: props.token },
        }
      )
      .then(function (response) {
        setIsPayrunApproved(response.data.rows[0].isPayrunApproved);
        setDocumentsList(response.data.rows);
        getBpName();
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getWizardName = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/wizardName/` + approvalId, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setWizardName(response.data.WizardName);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const navBackButtonHandler = () => {
    props.history.goBack();
  };

  useEffect(() => {
    getPayrunSupplierDocs();
    getWizardName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reRenderTrigger]);

  const dialogRef = useRef();
  const openDialogHandler = useCallback(
    (e) => {
      setRejectionOption(e.target.id);
      dialogRef.current.open();
    },
    [dialogRef]
  );

  const closeDialogHandler = useCallback(() => {
    dialogRef.current.close();
    setRejectionReasonCode("");
    setRejectionReasonComments("");
  }, [dialogRef]);

  const renderObjType = (objType) => {
    switch (objType) {
      case "18":
        return "PU";
      case "19":
        return "A/P Credit Memo";
      case "20":
        return "Goods Receipt PO";
      case "21":
        return "Goods Return";
      case "30":
        return "Journal Entry";
      default:
        return null;
    }
  };

  const onRejectReasonCodeChangeHandler = (e) => {
    setRejectionReasonCode(e.parameters.value);
  };

  const onRejectReasonCommentsInputHandler = (e) => {
    setRejectionReasonComments(e.parameters.value);
  };

  const changeTriggerValue = () => {
    if (reRenderTrigger === false) {
      setReRenderTrigger(true);
    } else {
      setReRenderTrigger(false);
    }
  };

  const onApproveAllHandler = async () => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(
        `/api/payruns/docs/` +
          approvalId +
          `/` +
          supplierId +
          `/user/` +
          props.user,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.token,
          },
        }
      )
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/docs/` + approvalId + `/` + supplierId + `/approved`,
            {
              approvalUserCode: props.user,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          setError(error.response.data.message);
        }
      });
  };

  const onRejectAllHandler = async () => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(
        `/api/payruns/docs/` +
          approvalId +
          `/` +
          supplierId +
          `/user/` +
          props.user,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.token,
          },
        }
      )
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/docs/` + approvalId + `/` + supplierId + `/rejected`,
            {
              approvalUserCode: props.user,
              rejectReasonName: rejectionReasonCode,
              reasonRejectComments: rejectionReasonComments,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            closeDialogHandler();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              closeDialogHandler();
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          closeDialogHandler();
          setError(error.response.data.message);
        }
      });
  };

  const onApproveHandler = async (docNum, objType) => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(
        `/api/payruns/` +
          approvalId +
          `/docs/` +
          docNum +
          `/type/` +
          objType +
          `/user/` +
          props.user,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.token,
          },
        }
      )
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/` + approvalId + `/docs/` + docNum + `/approved`,
            {
              objType: objType,
              approvalUserCode: props.user,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          setError(error.response.data.message);
        }
      });
  };

  const onRejectHandler = async () => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(
        `/api/payruns/` +
          approvalId +
          `/docs/` +
          rejectionDocNum +
          `/type/` +
          rejectionObjType +
          `/user/` +
          props.user,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.token,
          },
        }
      )
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/` +
              approvalId +
              `/docs/` +
              rejectionDocNum +
              `/rejected`,
            {
              objType: rejectionObjType,
              approvalUserCode: props.user,
              rejectReasonName: rejectionReasonCode,
              reasonRejectComments: rejectionReasonComments,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            closeDialogHandler();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              closeDialogHandler();
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          closeDialogHandler();
          setError(error.response.data.message);
        }
      });
  };

  const onSubmitRejectionHandler = () => {
    if (rejectionOption === "reject_one") {
      onRejectHandler();
    } else {
      onRejectAllHandler();
    }
  };

  const renderClassName = (approvalStatus) => {
    switch (approvalStatus) {
      case "A":
        return "green";
      case "R":
        return "red";
      default:
        return null;
    }
  };

  return (
    <Page
      title={title}
      showFooter={false}
      showHeader={true}
      showBackButton={true}
      backgroundDesign={PageBackgroundDesign.Transparent}
      onNavButtonPress={navBackButtonHandler}
    >
      <div className="container">
        <Title className="title" level={TitleLevel.H3} wrap={false}>
          {bpName}
          <br />
        </Title>
        <Title className="title" level={TitleLevel.H4} wrap={false}>
          {wizardName}
        </Title>
      </div>
      <Table
        stickyColumnHeader={false}
        columns={[
          <TableColumn>
            <Text>Document</Text>
          </TableColumn>,
          <TableColumn>
            <Text>Pay Amount</Text>
          </TableColumn>,
        ]}
      >
        {documentsList.map((doc) => (
          <TableRow
            key={doc.DocNum}
            className={renderClassName(doc.ApprovalStatus)}
          >
            <TableCell>
              <div className="document__container">
                <Text>
                  {renderObjType(doc.ObjType)} {doc.DocNum}
                </Text>
                <br />
                <Text className="extra__info">
                  Due: {doc.ValDate} (
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: doc.LocCurr,
                    minimumFractionDigits: 2,
                  }).format(parseFloat(doc.TotalLoc))}
                  )
                </Text>
              </div>
            </TableCell>

            <TableCell>
              <div className="cell__container">
                {!isPayrunApproved && (
                  <span>
                    <Button
                      id="reject_one"
                      design={ButtonDesign.Negative}
                      icon="decline"
                      onClick={(e) => {
                        openDialogHandler(e);
                        setRejectionObjType(doc.ObjType);
                        setRejectionDocNum(doc.DocNum);
                      }}
                      disabled={disableButtons}
                    ></Button>
                  </span>
                )}
                <div className="cell__info">
                  <Text>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: doc.InvCurr,
                      minimumFractionDigits: 2,
                    }).format(parseFloat(doc.PymAmntFC))}
                  </Text>
                  <br />
                  <Text className="extra__info">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: doc.LocCurr,
                      minimumFractionDigits: 2,
                    }).format(parseFloat(doc.PymAmount))}
                  </Text>
                </div>
                {!isPayrunApproved && (
                  <span>
                    <Button
                      design={ButtonDesign.Positive}
                      icon="accept"
                      onClick={() => {
                        onApproveHandler(doc.DocNum, doc.ObjType);
                      }}
                      disabled={disableButtons}
                    ></Button>
                  </span>
                )}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </Table>
      {error && <MessageStripCompnt type="error" message={error} />}
      {!isPayrunApproved && (
        <div>
          <Button
            id="reject_all"
            design={ButtonDesign.Negative}
            icon="decline"
            onClick={openDialogHandler}
            className="button__rejectall"
            disabled={disableButtons}
          >
            (All)
          </Button>
          <Button
            design={ButtonDesign.Positive}
            icon="accept"
            onClick={onApproveAllHandler}
            className="button__acceptall"
            disabled={disableButtons}
          >
            (All)
          </Button>
        </div>
      )}
      <Dialog
        ref={dialogRef}
        stretch={false}
        initialFocus={""}
        footer={null}
        header={null}
        className="container"
      >
        <p>Please state the motive for the rejection:</p>
        <ComboBox
          disabled={false}
          filter={"StartsWithPerTerm"}
          filterValue={""}
          loading={false}
          placeholder={""}
          readonly={false}
          required={true}
          value={rejectionReasonCode}
          valueState={ValueState.None}
          onChange={onRejectReasonCodeChangeHandler}
        >
          {rejectReasons.map((reason) => (
            <ComboBoxItem key={reason.Code} text={reason.Name} />
          ))}
        </ComboBox>
        <p>Reject reason comments:</p>
        <TextArea
          disabled={false}
          growing={false}
          growingMaxLines={0}
          maxlength={null}
          name={undefined}
          placeholder={""}
          readonly={false}
          required={false}
          rows={0}
          showExceededText={false}
          value={rejectionReasonComments}
          valueState={ValueState.None}
          valueStateMessage={<span>Value State Message</span>}
          onInput={onRejectReasonCommentsInputHandler}
        />
        <div className="buttons_container">
          {error && <MessageStripCompnt type="error" message={error} />}
          <Button
            className="btn__submitall"
            design={ButtonDesign.Negative}
            onClick={closeDialogHandler}
          >
            Cancel
          </Button>
          <Button
            className="btn__submitall"
            design={ButtonDesign.Positive}
            onClick={onSubmitRejectionHandler}
            disabled={disableButtons}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </Page>
  );
};

export default withRouter(DocumentDetails);
